import React from 'react'
import { Navigate, useLocation } from 'react-router-dom';
import { Routes } from '../constants/RouteConstants';
import { useSelector } from 'react-redux';
import { ProfileType } from '../constants/Constants';
import { Config } from '../config/Config';
import {
    SUBSCRIPTION_EXEMPT_PATH_SEGMENTS,
    SUBSCRIPTION_EXPIRED_LOCKED_PATH_SEGMENTS,
    salonOwnerNeedsSubscription,
    salonOwnerSubscriptionExpired,
    salonOwnerSubscriptionSuspended,
} from '../utils/subscriptionAccess';


const PrivateRoute = ({ component: Component }: any): React.ReactElement => {
    const profileData = useSelector((state: any) => state.GetProfileState);
    const location = useLocation();

    let forbidden_pages = ["profile", "complete-profile", "staff-member", "service-update", "service-management/view"];

    /** First URL segment (matches Router basename — do not use window.location.pathname here). */
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const current_page_1 = pathSegments[0] ?? '';


    if (localStorage.getItem('isUserLoginToken')) {
        if (Config?.USER_DETAILS?.role_id == 2) {
            if (forbidden_pages.includes(current_page_1)) {
                return (
                    <>
                        <Component />
                        <Navigate to={Routes?.Dashboard} />
                    </>
                )
            }
            else {
                return (
                    <>
                        <Component />
                    </>
                )
            }
        }
        else if (Config?.USER_DETAILS?.is_profile_setup == ProfileType?.CompanyProfile) {

            return (
                <>
                    <Component />
                    <Navigate to={Routes?.Profile} />
                </>
            )
        }
        else if (Config?.USER_DETAILS?.is_profile_setup == ProfileType?.ProfileDetail) {
            return (

                <>
                    <Component />
                    <Navigate to={Routes?.ProfileDetail} />
                </>
            )

        } else if (Config?.USER_DETAILS?.is_profile_setup == ProfileType?.CompleteProfile && Config?.USER_DETAILS?.is_approved == 0) {
            return (

                <>
                    <Component />
                    <Navigate to={Routes?.Home} />
                </>
            )
        }

        if (!profileData?.loading) {
            const u =
                profileData?.status && profileData?.data?.data
                    ? profileData.data.data
                    : Config?.USER_DETAILS;
            if (salonOwnerSubscriptionSuspended(u)) {
                if (
                    SUBSCRIPTION_EXPIRED_LOCKED_PATH_SEGMENTS.includes(
                        current_page_1,
                    )
                ) {
                    return (
                        <>
                            <Component />
                            <Navigate to={Routes.Dashboard} replace />
                        </>
                    );
                }
            } else if (salonOwnerSubscriptionExpired(u)) {
                if (
                    SUBSCRIPTION_EXPIRED_LOCKED_PATH_SEGMENTS.includes(
                        current_page_1,
                    )
                ) {
                    return (
                        <>
                            <Component />
                            <Navigate to={Routes.Dashboard} replace />
                        </>
                    );
                }
            } else if (salonOwnerNeedsSubscription(u)) {
                if (!SUBSCRIPTION_EXEMPT_PATH_SEGMENTS.includes(current_page_1)) {
                    return (
                        <>
                            <Component />
                            <Navigate to={Routes.Dashboard} replace />
                        </>
                    );
                }
            }
        }

        return <Component />;
    }
    else {
        return <>
            <Component />
            <Navigate to={Routes?.Login} />
        </>
        // return <Navigate to={Routes?.Login} />;
    }
}


export default PrivateRoute;



